import script from "./PaySolutionHiddenForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PaySolutionHiddenForm.vue?vue&type=script&setup=true&lang=js"

import "./PaySolutionHiddenForm.vue?vue&type=style&index=0&id=5afcf2b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5afcf2b2"]])

export default __exports__